
    const data = {"name":"src/core/icons/play","data":{"viewBox":"0 0 24 24","data":"<path pid=\"0\" d=\"M8 5.14v14l11-7-11-7Z\"/>","originalColors":[],"stopColors":[]}}

            export default data
            